import React, { useState } from 'react';

/**
 * Компонент для отображения панели валидации с детальной информацией об ошибках и предупреждениях
 */
const ValidationPanel = ({ validationErrors, hasValidationErrors, onValidate }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!hasValidationErrors && validationErrors.schema.warnings.length === 0 && validationErrors.uiSchema.warnings.length === 0) {
    return null;
  }

  const totalErrors = validationErrors.schema.errors.length + validationErrors.uiSchema.errors.length;
  const totalWarnings = validationErrors.schema.warnings.length + validationErrors.uiSchema.warnings.length;

  return (
    <div className="validation-panel my-3 p-0">
      {/* Заголовок панели */}
      <div 
        className={`alert ${hasValidationErrors ? 'alert-danger' : 'alert-warning'} d-flex justify-content-between align-items-center`}
        role="alert"
        style={{ cursor: 'pointer' }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div>
          <h6 className="alert-heading mb-0">
            {hasValidationErrors ? '⚠️ Ошибки валидации' : '⚠️ Предупреждения'}
            {totalErrors > 0 && <span className="badge bg-danger ms-2">{totalErrors}</span>}
            {totalWarnings > 0 && <span className="badge bg-warning text-dark ms-1">{totalWarnings}</span>}
          </h6>
        </div>
        <div className='me-3'>
          <span className="fs-5">{isExpanded ? '▼' : '▶'}</span>
        </div>
      </div>

      {/* Детальная информация */}
      {isExpanded && (
        <div className="card">
          <div className="card-body">
            {/* Ошибки JSON Schema */}
            {validationErrors.schema.errors.length > 0 && (
              <div className="mb-3">
                <h6 className="text-danger">
                  <i className="fas fa-exclamation-circle me-1"></i>
                  JSON Schema - Ошибки ({validationErrors.schema.errors.length})
                </h6>
                <ul className="list-group list-group-flush">
                  {validationErrors.schema.errors.map((error, index) => (
                    <li key={index} className="list-group-item text-danger">
                      <small>{error}</small>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Ошибки UI Schema */}
            {validationErrors.uiSchema.errors.length > 0 && (
              <div className="mb-3">
                <h6 className="text-danger">
                  <i className="fas fa-exclamation-circle me-1"></i>
                  UI Schema - Ошибки ({validationErrors.uiSchema.errors.length})
                </h6>
                <ul className="list-group list-group-flush">
                  {validationErrors.uiSchema.errors.map((error, index) => (
                    <li key={index} className="list-group-item text-danger">
                      <small>{error}</small>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Предупреждения JSON Schema */}
            {validationErrors.schema.warnings.length > 0 && (
              <div className="mb-3">
                <h6 className="text-warning">
                  <i className="fas fa-exclamation-triangle me-1"></i>
                  JSON Schema - Предупреждения ({validationErrors.schema.warnings.length})
                </h6>
                <ul className="list-group list-group-flush">
                  {validationErrors.schema.warnings.map((warning, index) => (
                    <li key={index} className="list-group-item text-warning">
                      <small>{warning}</small>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Предупреждения UI Schema */}
            {validationErrors.uiSchema.warnings.length > 0 && (
              <div className="mb-3">
                <h6 className="text-warning">
                  <i className="fas fa-exclamation-triangle me-1"></i>
                  UI Schema - Предупреждения ({validationErrors.uiSchema.warnings.length})
                </h6>
                <ul className="list-group list-group-flush">
                  {validationErrors.uiSchema.warnings.map((warning, index) => (
                    <li key={index} className="list-group-item text-warning">
                      <small>{warning}</small>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Рекомендации */}
            <div className="mt-3">
              <h6 className="text-info">
                <i className="fas fa-lightbulb me-1"></i>
                Рекомендации
              </h6>
              <ul className="list-unstyled">
                <li className="text-muted">
                  <small>• Исправьте все ошибки перед сохранением формы</small>
                </li>
                <li className="text-muted">
                  <small>• Обратите внимание на предупреждения для улучшения качества схемы</small>
                </li>
                <li className="text-muted">
                  <small>• Убедитесь, что все поля в UI Schema соответствуют полям в JSON Schema</small>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ValidationPanel;
